function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 9,
  r: 5,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 0C7.03734 0 3 4.00679 3 8.93181C3 11.6867 4.42917 15.0304 7.24793 18.8701C9.31072 21.6802 11.3434 23.6843 11.4289 23.7683C11.5862 23.9226 11.793 24 12.0001 24C12.2012 24 12.4024 23.927 12.5584 23.7805C12.6441 23.7 14.6819 21.777 16.7486 19.0058C19.5696 15.2229 21 11.8336 21 8.93177C20.9999 4.00679 16.9625 0 12 0ZM12 12.7878C9.57377 12.7878 7.59999 10.8635 7.59999 8.49822C7.59999 6.13295 9.57382 4.20863 12 4.20863C14.4261 4.20863 16.3999 6.13295 16.3999 8.49822C16.3999 10.8635 14.426 12.7878 12 12.7878Z",
  fill: "#51169D"
});

function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.d2c93829.svg";
export { ForwardRef as ReactComponent };